'use client';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { useMediaQuery } from 'react-responsive';
import { Markdown } from '@repo/ui/src/components/Markdown';

import HeaderVariety from './header-variety';

const SingleColumnText = ({
  description,
  title,
  subTitle,
  titleAlign,
  link,
  asButton,
  headerVariation,
  order,
  _testID,
}) => {
  const isMediumOrSmallerScreen = useMediaQuery({ query: '(max-width: 767px)' });
  const _link = link?.[0];

  return (
    <div
      className="tw-flex tw-justify-center tw-mb-0 tw-py-12 tw-px-5 lg:tw-px-0"
      style={{ zIndex: order }}
      data-test-id={`single_column_text_${_testID}`}
    >
      <div className="tw-container tw-max-w-[1200px]">
        {/* ALIGN TITLE LEFT */}
        {titleAlign === 'Left' ? (
          <div className="tw-grid tw-grid-cols-[1fr_2fr]">
            <div className="tw-px-3 tw-flex tw-justify-center">
              {title && (
                <HeaderVariety
                  defaultVariation="h2"
                  headerVariation={headerVariation?.headerVariation}
                >
                  {title}
                </HeaderVariety>
              )}
            </div>
            <div>
              {subTitle ? (
                <div className="row">
                  <h4 className="tw-pl-3">{subTitle}</h4>
                </div>
              ) : null}
              {description ? (
                <div className="row">
                  <div className="tw-pl-3 tw-m-auto">
                    <Markdown className="tw-break-words tw-max-w-paragraph">{description}</Markdown>
                  </div>
                </div>
              ) : null}
              {_link && (
                <div className="tw-mb-3">
                  <div className={asButton ? 'tw-pl-3 mr-md-auto' : 'tw-pl-3'}>
                    {asButton ? (
                      <Button as={Anchor} {..._link} className="tw-px-12">
                        {_link.displayName}
                      </Button>
                    ) : (
                      <Anchor {..._link} className="tw-underline tw-font-bold">
                        {_link.displayName}
                      </Anchor>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : null}

        {/* ALIGN TITLE RIGHT */}
        {titleAlign === 'Right' ? (
          <div className="row">
            {isMediumOrSmallerScreen ? (
              <div className="tw-text-right">
                {title && (
                  <HeaderVariety
                    defaultVariation="h2"
                    headerVariation={headerVariation?.headerVariation}
                  >
                    {title}
                  </HeaderVariety>
                )}
              </div>
            ) : null}
            <div className="col-12 col-md-9">
              {subTitle ? (
                <div className="row">
                  <h4 className="tw-pr-3">{subTitle}</h4>
                </div>
              ) : null}
              {description ? (
                <div className="row">
                  <div className="tw-text-right md:tw-text-left col-12 col-md-9">
                    <Markdown className="tw-break-words">{description}</Markdown>
                  </div>
                </div>
              ) : null}
              {_link && (
                <div
                  className={
                    isMediumOrSmallerScreen ? 'tw-flex tw-justify-items-end tw-mb-6' : 'col-9 mb-3'
                  }
                >
                  <div className={`${isMediumOrSmallerScreen ? '' : 'row'}`}>
                    {asButton ? (
                      <Button as={Anchor} {..._link} className="tw-px-12">
                        {_link.displayName}
                      </Button>
                    ) : (
                      <Anchor {..._link} className="tw-underline tw-font-bold">
                        {_link.displayName}
                      </Anchor>
                    )}
                  </div>
                </div>
              )}
            </div>
            {!isMediumOrSmallerScreen ? (
              <div className="col-12 col-md-3 text-right">
                {title && (
                  <HeaderVariety
                    defaultVariation="h2"
                    headerVariation={headerVariation?.headerVariation}
                  >
                    {title}
                  </HeaderVariety>
                )}
              </div>
            ) : null}
          </div>
        ) : null}

        {/* ALIGN TITLE CENTER */}
        {titleAlign === 'Center' || !titleAlign ? (
          <div className="tw-px-2">
            <div className={'tw-flex tw-justify-center tw-items-center tw-text-center tw-px-0'}>
              {title && (
                <HeaderVariety
                  defaultVariation="h2"
                  headerVariation={headerVariation?.headerVariation}
                  className="tw-flex tw-justify-center tw-px-4 tw-pb-8"
                >
                  {title}
                </HeaderVariety>
              )}
            </div>
            {subTitle ? (
              <div>
                <h4 className="tra-text-web-heading-4 tw-flex tw-justify-center tw-text-center tw-px-4 tw-pb-6">
                  <div className="tw-flex tw-justify-content tw-mx-auto">{subTitle}</div>
                </h4>
              </div>
            ) : null}
            {description ? (
              <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-center">
                <Markdown className="tw-max-w-paragraph tw-m-auto tw-break-words">
                  {description}
                </Markdown>
              </div>
            ) : null}
            {_link ? (
              <div>
                <div className="tw-flex tw-mb-3 tw-justify-center">
                  <div className={`tw-mx-auto ${isMediumOrSmallerScreen ? 'tw-w-100' : ''}`}>
                    {asButton ? (
                      <Button as={Anchor} {..._link} className="tw-px-12">
                        {_link.displayName}
                      </Button>
                    ) : (
                      <Anchor {..._link} className="tw-underline tw-font-bold">
                        {_link.displayName}
                      </Anchor>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SingleColumnText;
